import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { IconButton } from "@mui/material";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

function PrevArrow({ onClick }) {
    return (
      <IconButton
        onClick={onClick}
        size="small"
        sx={{
          position: 'absolute', left: -30, top: '50%', transform: 'translateY(-50%)', zIndex: 2,
          color: '#1976d2', border: '1.5px solid #1976d2',
          bgcolor: '#fff', boxShadow: '0 1px 4px rgba(0,0,0,0.13)',
          width: 26, height: 26,
          '&:hover': { bgcolor: '#1976d2', color: '#fff', boxShadow: '0 2px 6px rgba(25,118,210,0.25)' },
          '&.slick-disabled': { opacity: 0.35, pointerEvents: 'none' },
        }}
      >
        <ArrowBackIosNewIcon sx={{ fontSize: 12 }} />
      </IconButton>
    );
  }

  function NextArrow({ onClick }) {
    return (
      <IconButton
        onClick={onClick}
        size="small"
        sx={{
          position: 'absolute', right: -30, top: '50%', transform: 'translateY(-50%)', zIndex: 2,
          color: '#1976d2', border: '1.5px solid #1976d2',
          bgcolor: '#fff', boxShadow: '0 1px 4px rgba(0,0,0,0.13)',
          width: 26, height: 26,
          '&:hover': { bgcolor: '#1976d2', color: '#fff', boxShadow: '0 2px 6px rgba(25,118,210,0.25)' },
          '&.slick-disabled': { opacity: 0.35, pointerEvents: 'none' },
        }}
      >
        <ArrowForwardIosIcon sx={{ fontSize: 12 }} />
      </IconButton>
    );
  }

const SliderWrapper = ({ children }) => {
    
    const settings = {
        dots: false,
        infinite: false,
        speed: 600,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />,
        responsive: [
            { breakpoint: 1200, settings: { slidesToShow: 3 } },
            { breakpoint: 900, settings: { slidesToShow: 2 } },
            { breakpoint: 600, settings: { slidesToShow: 1, slidesToScroll: 1, arrows: true} }
        ]
    };

    return (<Slider {...settings}>{children}</Slider>);
}
export default SliderWrapper